import React from 'react';
import css from './Header.module.scss';

export default function ProjectItem({title, year, position, exploration}) {
  return (
    <header className={css.projectHeader}>
      <h1>{title}</h1>
      <div className={css.projectHeaderMeta}>
        <p>Year <span>{year}</span></p>
        <p>{position ? "Role" : "Project"} <span>{position}{exploration}</span></p>
      </div>
    </header>
  )
}
